import clsx from "clsx";
import { ComponentProps } from "react";

import { IUserResource } from "@sol/sdk";
import { Avatar } from "@sol/uikit/data-display/Avatar/Avatar";
type Props = { user: Partial<IUserResource> } & ComponentProps<typeof Avatar>;

export const UserAvatar = ({ user, className, ...props }: Props) => {
    return (
        <Avatar src={user.avatarUrl} {...props} className={clsx("text-ant-white shrink-0 bg-primary", className)}>
            {(user?.name && user?.surname
                ? `${user.name.charAt(0)}${user.surname.charAt(0)}`
                : (user?.email?.substring(0, 2) ?? "")
            ).toUpperCase()}
        </Avatar>
    );
};
